import dataURItoBlob from 'blueimp-canvas-to-blob'

const getVideoImage = (video, width = 290, height = 145) => {
  const canvas = document.createElement('canvas')
  canvas.height = height
  canvas.width = width
  const ctx = canvas.getContext('2d')
  ctx.drawImage(video, 0, 0, width, height)
  return dataURItoBlob(canvas.toDataURL('image/jpeg'))
}

const getVideoSource = source => {
  const video = document.createElement('video')
  const sourceSrc = document.createElement('source')
  sourceSrc.setAttribute('src', source);
  video.appendChild(sourceSrc);
  const promise = new Promise(resolve => {
    video.addEventListener('canplay', advanceVideoToTenPercent)
    video.addEventListener('timeupdate', () => resolve(video))
  });
  return promise
}

const advanceVideoToTenPercent = event => {
  const video = event.target
  if (!isNaN(video.duration)) {
    video.removeEventListener('canplay', advanceVideoToTenPercent)
    video.currentTime = Math.floor(video.duration + (video.duration * .1))
  }
}

export { getVideoImage, getVideoSource }



// WEBPACK FOOTER //
// ./src/Lib/CaptureVideoImage.js